import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import { BarGraphBar } from "./BarGraphBar";
import { TrendArrow } from "./TrendArrow";

interface DashboardMetricTileProps {
  name: string;
  value: string;
  trendArrow?: "up" | "down" | null;
  inverseTrendArrowStyle?: boolean;
  subText?: string | null;
  subTextStyle?: "green" | "amber" | "red" | null;
  barGraphValue?: number; // Number between 0 and 1 as a percentage
  barGraphStyle?: "green" | "amber" | "red" | null;
}

export const DashboardMetricTile: FC<DashboardMetricTileProps> = (props) => {
  return (
    <div className={" bg-slate-100 rounded-lg border border-slate-200 px-3 py-2"}>
      <div className={"flex items-start justify-between"}>
        <div>{props.name}</div>
        <div>
          <TrendArrow
            trend={props.trendArrow ?? null}
            trendStyle={
              props.inverseTrendArrowStyle ? (props.trendArrow === "up" ? "red" : "green") : null
            }
          />
        </div>
      </div>
      <div className={"text-2xl mt-2"}>{props.value}</div>
      {props.barGraphValue !== undefined && (
        <BarGraphBar
          size={"h-2"}
          value={props.barGraphValue}
          style={props.barGraphStyle ?? "default"}
        />
      )}
      {props.subText !== undefined && props.subText !== null && (
        <div
          className={`text-xs mt-2 ${props.subTextStyle === "green" ? "text-green-700" : props.subTextStyle === "amber" ? "text-amber-700" : "text-red-700"}`}
        >
          {props.subText}
        </div>
      )}
    </div>
  );
};
